import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardFooter } from './ui/Card';
import { Button } from './ui/Button';
import { Home, Briefcase, CalendarClock, Check } from 'lucide-react';
export function ServicesSection() {
  const services = [{
    icon: <Home className="w-6 h-6" data-id="element-256" />,
    title: 'Residential Cleaning',
    description: 'Deep clean, standard clean, and move-in / move-out cleaning tailored to your home.',
    options: ['Deep Clean', 'Standard Clean', 'Move-in / Move-out', 'Post-construction']
  }, {
    icon: <Briefcase className="w-6 h-6" data-id="element-257" />,
    title: 'Commercial Cleaning',
    description: 'Offices, retail, and small commercial spaces cleaned right every time.',
    options: ['Office Buildings', 'Retail Spaces', 'Small Commercial', 'After-hours available']
  }, {
    icon: <CalendarClock className="w-6 h-6" data-id="element-258" />,
    title: 'Recurring Plans',
    description: 'Weekly, bi-weekly, and monthly schedules for consistent cleanliness.',
    options: ['Weekly', 'Bi-weekly', 'Monthly', 'Custom schedules']
  }];
  return <section id="services" className="py-20 md:py-28 bg-white" data-id="element-259">
      <div className="container mx-auto px-4" data-id="element-260">
        <div className="text-center max-w-2xl mx-auto mb-16" data-id="element-261">
          <span className="text-brand-green font-semibold tracking-wider uppercase text-sm mb-3 block" data-id="element-262">
            What We Offer
          </span>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-brand-navy" data-id="element-263">
            Our Cleaning Services
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12" data-id="element-264">
          {services.map((service, index) => <Card key={index} className="border border-gray-100 shadow-sm hover:shadow-lg transition-all duration-300 rounded-2xl flex flex-col h-full" data-id="element-265">
              <CardHeader className="pb-4" data-id="element-266">
                <div className="w-12 h-12 rounded-xl bg-brand-navy/5 flex items-center justify-center mb-4 text-brand-navy" data-id="element-267">
                  {service.icon}
                </div>
                <CardTitle className="text-2xl font-heading font-bold text-gray-900" data-id="element-268">
                  {service.title}
                </CardTitle>
                <p className="text-gray-600 mt-2 font-body" data-id="element-269">
                  {service.description}
                </p>
              </CardHeader>
              <CardContent className="flex-grow" data-id="element-270">
                <ul className="space-y-3" data-id="element-271">
                  {service.options.map((option, i) => <li key={i} className="flex items-start text-gray-700" data-id="element-272">
                      <Check className="w-5 h-5 text-brand-green mr-3 flex-shrink-0 mt-0.5" data-id="element-273" />
                      <span data-id="element-274">{option}</span>
                    </li>)}
                </ul>
              </CardContent>
              <CardFooter className="pt-6 border-t border-gray-50" data-id="element-275">
                <a href="#quote" className="w-full" data-id="element-276">
                  <Button variant="outline" className="w-full rounded-full h-12 text-brand-navy border-gray-200 hover:border-brand-navy hover:bg-brand-navy hover:text-white transition-colors font-semibold" data-id="element-277">
                    Get a Quote
                  </Button>
                </a>
              </CardFooter>
            </Card>)}
        </div>

        <div className="text-center" data-id="element-278">
          <Button className="brand-gradient text-white rounded-full h-14 px-10 font-semibold text-lg border-0 hover:opacity-90 shadow-md" data-id="element-279">
            View All Services
          </Button>
        </div>
      </div>
    </section>;
}